import { useEffect } from 'react';
import { onCLS } from 'web-vitals';
import { logger } from '@/lib/logger';

/**
 * 📊 CLS Reporter Component
 * 
 * Tracks Cumulative Layout Shift (CLS) and logs issues to console
 * in development for debugging visual stability problems.
 * 
 * Google's CLS thresholds:
 * - Good: < 0.1
 * - Needs Improvement: 0.1 - 0.25
 * - Poor: > 0.25
 */
export const CLSReporter = () => {
  useEffect(() => {
    // Only run in development
    if (import.meta.env.DEV) {
      onCLS((metric) => {
        const { value, entries } = metric;

        // Log CLS score
        if (value > 0.1) {
          logger.warn(`[CLSReporter] Layout shift detected`, {
            score: value,
            rating: metric.rating,
            entriesCount: entries.length,
          });
        }

        // Send to analytics in production (if you have analytics)
        if (import.meta.env.PROD && typeof window.gtag === 'function') {
          window.gtag('event', 'CLS', {
            value: Math.round(value * 1000),
            metric_rating: metric.rating,
            event_category: 'Web Vitals',
            non_interaction: true,
          });
        }
      });
    }
  }, []);

  return null;
};
